const V13Styles = () => (
  <style>{`
    .v13-root { cursor: none; }
    .v13-root *, .v13-root a, .v13-root button { cursor: none !important; }
    .v13-root input, .v13-root textarea, .v13-root select { cursor: auto !important; }
    @media (pointer: coarse) { .v13-root, .v13-root *, .v13-root a, .v13-root button { cursor: auto !important; } }
    @keyframes v13-scroll-bob { 0%,100%{transform:translateY(0);opacity:1}50%{transform:translateY(6px);opacity:0.3} }
    .v13-scroll-bob { animation: v13-scroll-bob 2s ease-in-out infinite; }
    @keyframes fadeIn { from { opacity:0 } to { opacity:1 } }
    /* V13-specific footer: green instead of black */
    .v13-root .footer { background: #0A4F3B !important; }
    .v13-root .footer-divider { background: rgba(255, 255, 255, 0.18) !important; }
  `}</style>
);
export default V13Styles;